import * as TechIssuesSelector from './tech-issue.selectors';
import {SharedIssueBaseSelectors} from "@shared/components/issues/store/shared-issue-base.selectors-type";

const TechIssuesSelectorsMerge = { ...TechIssuesSelector, ...SharedIssueBaseSelectors };
export {TechIssuesSelectorsMerge as TechIssuesSelectors};
